export const TRADEIN = 'TRADEIN'
export const TRADEIN5 = 'TRADEIN5'
export const CERTIFICATE = 'CERTIFICATE'
export const COMM_DIRECTOR = 'COMM_DIRECTOR'
export const PROMO = 'PROMO'
export const EMPLOYEE = 'EMPLOYEE'
export const BONUS = 'BONUS'
export const EXTRA = 'EXTRA'
export const ROMAN_GRABINSKI = 'ROMAN_GRABINSKI'

export const DISCOUNT_REASON = {
  [TRADEIN]: 'Скидка 2% по Трейд-ин',
  [EXTRA]: 'Наценка',
  [CERTIFICATE]: 'Сертификат на скидку 50 000 тг.',
  [COMM_DIRECTOR]: 'Скидка согласованна ком.диром сети',
  [PROMO]: 'Акция',
  [EMPLOYEE]: 'Продажа сотруднику',
  [BONUS]: 'Бонусы',
  [ROMAN_GRABINSKI]: 'От Романа Грабинского'
}

export const extraOptions = [
  { value: '', label: 'Не выбрано' },
  { value: 'OVER', label: 'Овер' },
  { value: 'OVER_PEREKIDKA', label: 'Овер + перекидка' },
  { value: 'OVER_NDS', label: 'Овер НДС юр лицо' }
]

export const getExtraOptionsName = options => {
  switch (options) {
    case 'OVER':
      return 'Овер'
    case 'OVER_PEREKIDKA':
      return 'Овер + перекидка'
    case 'OVER_NDS':
      return 'Овер НДС юр лицо'
    case 'OVER_SECRET_DAD':
      return 'Овер секрет отца'
    default:
      return '-'
  }
}
